import type { IconProps } from '../types/IconProps.ts';
export const UsersShield: IconProps = {
    name: 'UsersShield',
    children: [
        `<path d="M11 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10" />`,
        `<path d="M14.15 12.64A8 8 0 0 0 3 20M16 16.12q0-.08.09-.08c.91 0 1.8-.29 2.54-.8l.3-.22q.07-.04.14 0l.3.21c.73.52 1.63.8 2.54.8q.08 0 .09.09v2.36A3.7 3.7 0 0 1 19 22a3.7 3.7 0 0 1-3-3.52z" />`,
    ]
};